export default "__VITE_ASSET__DBHwAZKz__"